<template>
  <v-row
    class="pb-2"
    no-gutters
    style="display: flex; flex-direction: column; align-items: center">
    <h2 class="text-center pb-4">
      Please provide your card details to complete subscription:
    </h2>
    <v-col
      class="stripe-card-container elevation-1 mb-3"
      style="border: 1px solid rgba(0, 0, 0, 0.1); max-width: 500px">
      <form
        id="payment-form"
        class="sr-payment-form">
        <div class="sr-combo-inputs-row">
          <div
            id="card-element"
            data-test="creditcard_number_input_field"
            class="sr-input sr-card-element"
            style="padding: 1rem;background: #fff;border-radius: 0.5rem;" />
        </div>
        <p
          id="card-errors"
          class="x-small-p red--text"
          role="alert">
          {{ error }}
        </p>
      </form>
      <v-row
        no-gutters
        justify="center"
        style="padding-bottom: 20px;">
        <v-btn
          :loading="loading"
          data-test="pay_button"
          color="blue"
          class="payButton elevation-0 white--text"
          @click="pay()">
          Pay
        </v-btn>
      </v-row>
    </v-col>
  </v-row>
</template>
<script>
import PaymentsApi from '@/services/graphql/payments';
import {
  mapActions, mapMutations,
} from 'vuex';
import currencyController from '@/mixins/currencyController';
export default {
  name: 'PaymentUnlimitedUsers',
  mixins: [currencyController],
  data() {
    return {
      stripe: null,
      card: null,
      error: '',
      loading: false,
    };
  },
  async mounted() {
    await this.initCurrencyController();
    this.setupElements();
  },
  methods: {
    ...mapActions({
      handleError: 'handleError',
    }),
    ...mapMutations(['openSnackBar']),

    async pay() {
      if (!this.stripe || !this.card) {
        console.error(`Stripe element or card missing? stripe:${this.stripe} card:${this.card}`);
      }
      this.loading = true;
      this.error = '';
      try {
        const { currency = '' } = this.currencyController || {
        };
        const paymentMethodId = await this.createAndAttachPaymentMethod(currency);
        this.$emit(
          'stripeSubUnlimitedUsers',
          paymentMethodId,
          currency,
        );
        this.$emit('paymentModel', false);
      } catch (err) {
        this.error = err;
        this.loading = false;
        console.log('Error making payment', err);
        this.openSnackBar({
          text: 'Error making payment. Please try again. If failure persists, please contact support',
        });
      }
    },
    async createAndAttachPaymentMethod(currency) {
      const createPMResponse = await this.stripe.createPaymentMethod({
        type: 'card',
        card: this.card,
      });
      if (createPMResponse.error) {
        throw new Error(createPMResponse.error.message);
      }
      const paymentMethodId = createPMResponse.paymentMethod.id;
      const attachPMResp = await PaymentsApi.saveAndAttachPaymentMethodId({
        paymentMethodId: paymentMethodId,
        currency,
      });
      if (!attachPMResp.data.response.success === true) {
        throw new Error(attachPMResp.data.response.message);
      }
      return paymentMethodId;
    },
    setupElements() {
      // const stripe = window.Stripe('pk_test_51Hvg8oHTOrfLh7WUcFpVn6kXzpRWIVdVe0fYw1Q6c5XDR6NmTDC6liWwS8SzzZaKShUDqAr5pUerQisxH0QZmXJN00myTqtEnU');
      const stripe = window.Stripe(process.env.VUE_APP_STRIPE_API_KEY);
      const elements = stripe.elements();
      const style = {
        base: {
          color: '#8CA3A9',
          fontFamily: '"Roboto", sans-serif',
          backgroundColor: '#fff',
          fontSmoothing: 'antialiased',
          fontSize: '16px',
          '::placeholder': {
            color: '#aab7c4',
          },
        },
        invalid: {
          color: '#fa755a',
          iconColor: '#fa755a',
        },
      };
      const card = elements.create('card', {
        style,
      });
      card.mount('#card-element');
      card.on('change', e => {
        if (e.error) {
          this.error = e.error.message;
        } else {
          this.error = '';
        }
      });
      this.stripe = stripe;
      this.card = card;
    },
  },
};
</script>
<style lang="scss" scoped></style>
